// extracted by mini-css-extract-plugin
export default {"payment":"Ey","title_row":"Fy","border_bottom":"Gy","promo_wrapper":"Hy","payment_wrapper":"Iy","label":"Jy","card_row":"Ky","cardcontain":"Ly","card_input":"My","card_error":"Ny","card_label":"Oy","lock":"Py","same_address":"Qy","place_order_button":"Ry","buttonwrap":"Sy","hide_form":"Ty","paypal_buttons":"Uy","review_button":"Vy","alt_payment":"Wy"};
    if(module.hot) {
      // 1713912565687
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  